import React from 'react';
import TextField from './TextField';

export default class TextArea extends TextField {

    constructor(props) {
        super(props);
        this._inputtype = (props) => <textarea {...props}> {props.children} </textarea>;
    }
}